import React from 'react';
import { Shield, Lock, CreditCard, Award } from 'lucide-react';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: Shield,
      title: 'SSL Secured',
      description: '256-bit encryption'
    },
    {
      icon: Lock,
      title: 'PCI Compliant',
      description: 'Industry standard'
    },
    {
      icon: CreditCard,
      title: 'Secure Payments',
      description: 'Protected transactions'
    },
    {
      icon: Award,
      title: 'Trusted',
      description: '10+ years experience'
    }
  ];

  return (
    <div className="flex items-center space-x-6">
      {/* Security Badges */}
      <div className="hidden md:flex items-center space-x-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-2 text-sm">
            <feature.icon className="w-4 h-4 text-green-600" />
            <div>
              <div className="font-medium text-gray-900">{feature?.title}</div>
              <div className="text-xs text-gray-500">{feature?.description}</div>
            </div>
          </div>
        ))}
      </div>
      {/* Mobile Security Indicators */}
      <div className="flex md:hidden items-center space-x-2">
        <Shield className="w-5 h-5 text-green-600" />
        <span className="text-sm font-medium text-gray-900">Secure Checkout</span>
      </div>
      {/* Payment Methods Accepted */}
      <div className="flex items-center space-x-2">
        <span className="text-sm text-gray-600">Accepted:</span>
        <div className="flex space-x-1">
          <div className="w-8 h-5 bg-blue-600 rounded text-white text-xs flex items-center justify-center">
            VISA
          </div>
          <div className="w-8 h-5 bg-red-600 rounded text-white text-xs flex items-center justify-center">
            MC
          </div>
          <div className="w-8 h-5 bg-blue-500 rounded text-white text-xs flex items-center justify-center">
            AMEX
          </div>
          <div className="w-8 h-5 bg-orange-500 rounded text-white text-xs flex items-center justify-center">
            PP
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;